import React, { Component } from "react";
import { withRouter } from "react-router";

import { withSensors } from "./../../../shared/containers/containerSensors";

import MapWrapper from "../../../shared/map/mapWrapper";
import MapMarker from "../../../shared/map/mapMarker";
import IntelligenceMapNoData from "./intelligenceMapNoData";

import { states } from "./../../../reducers/queriesStates";

class IntelligenceMapInMoment extends Component {
  constructor() {
    super();

    this.getSensors = this.getSensors.bind(this);
  }

  componentDidMount() {
    const { isSensorsDataReady } = this.props;

    if (!isSensorsDataReady) this.getSensors();
  }

  componentDidUpdate(prevProps) {
    const { sensorsDataState, sensorsData, onSetSensorsDataReady, onSetSensorsDataEmpty } = this.props;

    if (sensorsDataState === states.READY && prevProps.sensorsDataState === states.REQUEST) {
      if (Object.entries(sensorsData.sensors).length === 0) onSetSensorsDataEmpty();
      else onSetSensorsDataReady();
    }

    if (sensorsDataState === states.NOT_REQUESTED && prevProps.sensorsDataState !== states.NOT_REQUESTED)
      this.getSensors();
  }

  getSensors() {
    const { match, onGetSensors } = this.props;

    let date = new Date();
    date.setSeconds(0);

    onGetSensors(match.params.id, date);
  }
  
  render() {
    const { sensorsDataState, sensorsData, isSensorsDataReady } = this.props;
    let lat = sensorsData.location.lat;
    let long = sensorsData.location.long;
    let state = sensorsData.state.status;
    let number = sensorsData.number;
    let showMapControls = sensorsDataState !== states.REQUEST && sensorsDataState !== states.NOT_REQUESTED;

    if (isSensorsDataReady)
      return (
        <MapWrapper position={[lat, long]}>
          <MapMarker position={[lat, long]} status={state} number={number} />
        </MapWrapper>
      );
    else return <IntelligenceMapNoData showMapControls={showMapControls} handleClick={this.getSensors} />;
  }
}

export default withSensors(withRouter(IntelligenceMapInMoment));
